import { SlideContent } from '@/components/SlideContent';
import { OnboardingLayout, useSlideSetup } from '@/features/client-onboarding';
import { OnboardingFundingCoverage } from '@/pages/OnboardingFundingCoverage';
import { PolicyApplicationDashboard } from '@/pages/PolicyApplicationDashboard';
import { selectClient } from '@/model/selectors';
import { useIsEdjPilotAdvisor } from '@/shared/hooks/use-edj-pilot-advisor';

import { fullName } from '@shared';

import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';

export function OnboardingPolicyApplicationDashboard({
  clientId,
}: ClientIdProps) {
  const isEdjPilot = useIsEdjPilotAdvisor();
  const client = useSelector(selectClient);
  const clientName = fullName(client);

  useSlideSetup({
    slidePage: OnboardingPolicyApplicationDashboard,
    nextSlidePage: OnboardingFundingCoverage,
    nextButtonLabel: 'Next',
  });

  if (isEdjPilot) {
    return <Navigate to={`/clients/${clientId}/onboarding/funding-coverage`} replace />;
  }

  return (
    <OnboardingLayout>
      <SlideContent
        headerText={`Insurance Application Review `}
        headerSubText={`Review and manage insurance applications for ${clientName}.`}
        centerHeader={true}
      >
        <div className="mt-2 md:mt-8">
          <PolicyApplicationDashboard />
        </div>
      </SlideContent>
    </OnboardingLayout>
  );
}
